export default __webpack_public_path__ + "static/media/PerformanceChart.ded9e4db.png";